const registrationError = 'We\'re sorry, we\'ve encountered an error. Please try again.';
export default function registerBestDealsActionCreator(userDuck, personalization) {
  return _ref => {
    let {
      data,
      onRegisterSuccess = () => {}
    } = _ref;
    return async dispatch => {
      const {
        emailAddress,
        zip,
        userId,
        styleCodes // comma separated if applicable
      } = data;

      // query expected : email, zipcode, bestDealsOptIn, userId, and styleCodes
      const transformedData = {
        email: emailAddress,
        search: {
          bestDealsOptIn: 'y',
          userId,
          zipcode: zip,
          ...(styleCodes ? {
            styleCodes
          } : {})
        }
      };
      try {
        const saveEvent = await personalization.updateEmailBestDealsItem(transformedData);
        if (saveEvent.status === 200 || saveEvent.message && saveEvent.message.toLowerCase() === 'userexists') {
          onRegisterSuccess(saveEvent);
          // Show success message on successful registration

          dispatch(userDuck.creators.showBestDealsSubscribeSuccess(true));
        }
        return saveEvent;
      } catch (error) {
        dispatch(userDuck.creators.showBestDealsRegistrationServerError(registrationError));
        throw Error(error);
      }
    };
  };
}